import * as React from 'react'
import Svg, { Path, type SvgProps } from 'react-native-svg'

function MoreHorizontal(props: SvgProps) {
  return (
    <Svg width={24} height={24} viewBox="0 0 24 24" fill="none" {...props}>
      <Path
        d="M12.615 11.615a.615.615 0 11-1.23 0 .615.615 0 011.23 0zM20 11.615a.615.615 0 11-1.23 0 .615.615 0 011.23 0zM5.23 11.615a.615.615 0 11-1.23 0 .615.615 0 011.23 0z"
        fill="#152438"
      />
      <Path
        d="M12.615 11.615a.615.615 0 11-1.23 0 .615.615 0 011.23 0zM20 11.615a.615.615 0 11-1.23 0 .615.615 0 011.23 0zM5.23 11.615a.615.615 0 11-1.23 0 .615.615 0 011.23 0z"
        stroke="#152438"
        strokeWidth={1.5}
      />
    </Svg>
  )
}

export default MoreHorizontal
